import useProposalGenerationEventHandlers from "./useProposalGenerationEventHandlers";
import { useOwnChatStream } from "src/reusable/Chat/ChatStreaming/hooks/useOwnChatStream";
import { nuclearn_api_url } from "src/App";
import { ChatConfiguration } from "src/reusable/Chat/ChatStreaming/types";

export const useProposalGenerationChat = (
  config?: Partial<ChatConfiguration>,
  dialogue?: any[],
) => {
  const { metadataHandler, messageHandler } =
    useProposalGenerationEventHandlers();

  const streamingResult = useOwnChatStream(
    {
      api: `${nuclearn_api_url}/chat/start`,
      onMetadataEvent: metadataHandler,
      onMessageEvent: messageHandler,
      ...config,
    },
    dialogue,
  );

  return streamingResult;
};
